import React from "react";

class PrivacyPolicy extends React.Component {
  render() {
    return (
      <div style={{ paddingTop: "70px" }}>
        PERSONAL DATA PROTECTION POLICY <br />
        <br /> <b>Purpose</b> This Personal Data Protection Policy ("Policy")
        sets out the ways in which the FoodLeh collects, uses, discloses and
        retains personal information in order to carry out our activities and
        operations; and the measures we take to protect your personal
        information. The Policy is designed to meet the requirements of
        Singapore’s personal data protection laws. <b>Application of Policy</b>{" "}
        When you become a member of FoodLeh, you agree to the terms of this
        Policy as updated from time to time. This Policy applies to all FoodLeh
        members, non-members, users and content providers. From time to time,
        FoodLeh will update this Policy to ensure that this Policy is consistent
        with any changes in legal requirements. You are encouraged to
        periodically review this Policy to be informed of how FoodLeh is
        protecting your information.{" "}
        <b>Types of Personal Information collected</b> Our Policy applies to
        personal information that FoodLeh collects, uses and discloses in order
        to carry out FoodLeh’s activities and operations; and to enable you to
        access our website and dashboards. Personal information is any
        information that can identify an individual or information about an
        identifiable individual, such as an individual’s home address, telephone
        number, or a member’s transaction activity in relation to FoodLeh
        activities. When a member makes an order on FoodLeh, we may collect
        identifying information, such as (but not limited to) the member’s name,
        address, and telephone number. This Policy does not apply to aggregated
        information which summarises statistical information about groups of
        members, and which does not include name, contact information, or any
        other information that would allow any particular individual to be
        identified. <b>How we collect your Personal Information</b>
        Much of the personal information we collect comes from you, such as when
        you apply for membership or make orders through FoodLeh. We collect
        personal information, unless such is prohibited by legislation, when you
        contact us, register with us or when you require our services. Use of
        your Personal Information FoodLeh collects and uses your personal
        information to operate FoodLeh’s website, deliver the goods and/or
        services you have requested, and to administer FoodLeh’s activities.
        FoodLeh also uses your personally identifiable information to inform
        merchants of their transaction history. FoodLeh may also contact you via
        surveys to conduct research about your opinion of current services or of
        potential new services that may be offered. FoodLeh does not sell, rent
        or lease its member/customer lists to third parties. FoodLeh may share
        data with trusted partners in order to administer your membership, to
        help us perform statistical analysis, send you email or postal mail,
        provide customer support, or arrange for deliveries. All such third
        parties are prohibited from using your personal information except to
        provide these services to FoodLeh, and they are required to maintain the
        confidentiality of your information. FoodLeh keeps track of the websites
        and pages our members and customers visit within FoodLeh, in order to
        determine what FoodLeh services are the most popular. If you are only
        browsing the website of the FoodLeh, FoodLeh does not capture data that
        allows it to identify you individually. Where permitted under the
        Personal Data Protection Act, your Personal Data may be disclosed to
        FoodLeh’s Preferred Partners in connection with services offered by
        these Preferred Partners. Preferred Partners are organisations which
        share a business relationship with FoodLeh in areas such as marketing
        collaborations and co-branding. However, please be assured that we do
        not disclose your Personal Data to our Preferred Partners for the
        purposes of the above unless your consent is expressly obtained.{" "}
        <b>Security of your Personal Information</b> FoodLeh secures your
        personal information from unauthorised access, use or disclosure.
        FoodLeh secures the personally identifiable information you provide on
        computer servers in a controlled, secure environment, protected from
        unauthorised access, use or disclosure. FoodLeh will not share your
        personal information with third parties without your permission, except
        if required by law or a court order to do so. Withdrawing consent The
        collection and handling of certain personal information is necessary to
        maintain your membership and/or for processing transactions. You may,
        however, opt out of the collection and/or handling of your personal
        information for other purposes — including opting out of receiving
        marketing and promotional material from the FoodLeh group*. Contact
        Information If you have any questions or feedback relating to your
        Personal Data or our Data Protection Policy, please contact us at:
        foodleh@outlook.com
      </div>
    );
  }
}

export default PrivacyPolicy;
